import React, { useEffect, useState } from "react";
import Footer from "./Footer";

import LeftFadeIn from "../components/animations/LeftFadeIn";
import RightFadeIn from "../components/animations/RightFadeIn";
import SlideIn from "../components/animations/SlideIn";
import FadeIn from "../components/animations/FadeIn";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Bar, Pie } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: false,
      text: "Chart.js Bar Chart",
    },
  },
};

const labels = [
  "1st Month",
  "2nd Month",
  "3rd Month",
  "4th Month",
  "5th Month",
  "6th Month",
];


const Calculator = () => {
  // Input State
  const [area, setArea] = useState(1000);
  const [cost, setCost] = useState(1000);

  // Percentage Usage
  const [cement, setCement] = useState(0.0);
  const [sand, setSand] = useState(0.0);
  const [aggregate, setAggregate] = useState(0.0);
  const [steel, setSteel] = useState(0.0);
  const [finishers, setFinishers] = useState(0.0);
  const [fittings, setFittings] = useState(0.0);
  const [total, setTotal] = useState(0.0);

  // Material Usage
  const [cementUsage, setCementUsage] = useState(0.0);
  const [sandUsage, setSandUsage] = useState(0.0);
  const [aggregateUsage, setAggregateUsage] = useState(0.0);
  const [steelUsage, setSteelUsage] = useState(0.0);
  const [paintUsage, setPaintUsage] = useState(0.0);
  const [bricksUsage, setBricksUsage] = useState(0.0);
  const [flooringUsage, setFlooringUsage] = useState(0.0);

  // Charts States
  const [barChartData, setBarChartData] = useState({
    labels,
    datasets: [
      {
        label: "Dataset 1",
        data: labels.map(() => Math.random() * (250000 - 100000) + 100000),
        backgroundColor: "rgba(30, 144, 255, 0.5)",
      },
    ],
  })

  const [pieChartData, setPieChartData] = useState({
    labels: ["Cement", "Sand", "Aggregate", "Steel", "Paint", "Bricks", "Flooring"],
    datasets: [
      {
        label: "# of Votes",
        data: [12, 12, 12, 12, 12, 12],
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(175, 92, 92, 0.2)",
          "rgba(95, 107, 182, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(75, 192, 192, 1)",
        ],
        borderWidth: 3,
      },
    ],
  })

  const [reset, setReset] = useState(false)

  useEffect(() => {
    if(reset === true){
      setReset(false)
    }
    calculate()
  }, [reset])

  const roundNumber = (num, format=true) => {
    const rounded = num.toFixed(2)
    return format ? rounded.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'): rounded
  }

  const calculate = () => {
    const total = area * cost

    setCement(roundNumber(total * 0.164))
    setSand(roundNumber(total * 0.123))
    setAggregate(roundNumber(total * 0.074))
    setSteel(roundNumber(total * 0.246))
    setFinishers(roundNumber(total * 0.165))
    setFittings(roundNumber(total * 0.228))
    setTotal(roundNumber(total))

    setCementUsage(roundNumber(area * 0.40, false))
    setSandUsage(roundNumber(area * 0.82, false))
    setAggregateUsage(roundNumber(area * 0.61, false))
    setSteelUsage(roundNumber(area * 4.00, false))
    setPaintUsage(roundNumber(area * 0.18, false))
    setBricksUsage(roundNumber(area * 8.00, false))
    setFlooringUsage(roundNumber(area * 1.30, false))

    // Set Bat Chart Data
    setBarChartData({
      labels,
      datasets: [
        {
          label: "Cost Timeline",
          data: [
            roundNumber(total * 0.219, false),
            roundNumber(total * 0.184, false),
            roundNumber(total * 0.111, false),
            roundNumber(total * 0.169, false),
            roundNumber(total * 0.178, false),
            roundNumber(total * 0.139, false)
          ],
          backgroundColor: "rgba(30, 144, 255, 0.5)",
        },
      ],
    })

    // Set Pie Chart Data
    setPieChartData({
      labels: ["Cement", "Sand", "Aggregate", "Steel", "Finishers", "Fittings"],
      datasets: [
        {
          label: "# of Votes",
          data: [
            roundNumber(total * 0.164, false),
            roundNumber(total * 0.123, false),
            roundNumber(total * 0.074, false),
            roundNumber(total * 0.246, false),
            roundNumber(total * 0.165, false),
            roundNumber(total * 0.228, false),
          ],
          backgroundColor: [
            "rgba(255, 99, 132)",
            "rgba(54, 162, 235)",
            "rgba(255, 206, 86)",
            "rgba(75, 192, 192)",
            "rgba(175, 92, 92)",
            "rgba(95, 107, 182)",
          ],
          borderColor: [
            "rgba(255, 255, 255, 1)",
            "rgba(255, 255, 255, 1)",
            "rgba(255, 255, 255, 1)",
            "rgba(255, 255, 255, 1)",
            "rgba(255, 255, 255, 1)",
            "rgba(255, 255, 255, 1)",
          ],
          borderWidth: 3,
        },
      ],
    })
  }

  const resetHandler = () => {
    setArea(1000)
    setCost(1000)
    setReset(true)
  }

  return (
    <React.Fragment>
      <div className="container mb-5">
        {/* Calculator Input Box */}
        <div className="row" style={{ marginTop: "70px" }}>
          <div className="col-md-6">
            <LeftFadeIn>
              <div className="card">
                <div className="card-header" style={{backgroundColor: 'gray', color: 'white'}}>
                  <i className="fa fa-building"></i> CONSTRUCTION COST ESTIMATOR
                </div>
                <div className="card-body">
                  <div role="form" className="form-horizontal">
                    <div className="form-body">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-3"></div>
                          <label className="col-md-3 control-label">
                            Builtup Area
                          </label>
                          <div className="col-md-6">
                            <div className="input-group">
                              <input
                                name="area"
                                type="number"
                                value={area}
                                maxlength="7"
                                title="Enter builtup square feet"
                                className="form-control"
                                onChange={(event) => setArea(event.target.value)}
                              />
                              <span
                                className="input-group-text blue-theme-color"
                                style={{ width: "55px" }}
                              >
                                ft<sup>2</sup>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-1"></div>
                          <label className="col-md-5 control-label">
                            Approx Cost (Per Square Feet)
                          </label>
                          <div className="col-md-6">
                            <div className="input-group">
                              <input
                                name="area"
                                type="number"
                                value={cost}
                                maxlength="7"
                                title="Enter builtup square feet"
                                className="form-control"
                                onChange={(event) => setCost(event.target.value)}
                              />
                              <span
                                className="input-group-text blue-theme-color"
                                style={{ width: "55px" }}
                              >
                                Rs.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="float-right">
                    <button type="button" className="btn btn-primary" onClick={() => calculate()}>
                      Calculate
                    </button>
                    <button type="button" className="btn btn-danger ml-2" onClick={() => resetHandler()}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </LeftFadeIn>
          </div>
          <div className="col-md-1"></div>
          <div className="col-md-5">
            <video
              width="380"
              autoplay="true"
              muted="true"
              loop="true"
              src="/videos/buildex_home.mp4"
            />
          </div>
        </div>

        {/* Bar Chart Box */}
        <div className="card mt-5">
          <div className="card-header">
            <i className="fa fa-info mr-2"></i> Calculation of Cost | Approx
            amount of cost for given construction is {total} Rs.
          </div>
          <div className="card-body">
            <div className="row mt-1">
              <div className="col-md-6">
                <div class="card" style={{ width: "30rem" }}>
                  <div class="card-header">
                    Approximate cost on various work of materialas per thumb
                    rule
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      Cement (16.4 %){" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#428bca",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {cement} Rs.
                      </span>
                    </li>
                    <li class="list-group-item">
                      Sand (12.3 %){" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#89c4f4",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {sand} Rs.
                      </span>
                    </li>
                    <li class="list-group-item">
                      Aggregate (7.4 %){" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#dfba49",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {aggregate} Rs.
                      </span>
                    </li>
                    <li class="list-group-item">
                      Steel (24.6 %){" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#45b6af",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {steel} Rs.
                      </span>
                    </li>
                    <li class="list-group-item">
                      Finishers (16.5 %){" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#f3565d",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {finishers} Rs.
                      </span>
                    </li>
                    <li class="list-group-item">
                      Fittings (22.8 %){" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#45b6af",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {fittings} Rs.
                      </span>
                    </li>
                    <li class="list-group-item">
                      TOTAL COST{" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#f3565d",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {total} Rs.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <FadeIn>
                  <Bar options={options} data={barChartData} />
                </FadeIn>
              </div>
            </div>
          </div>
        </div>

        {/* Round Chart Box */}
        <div className="card mt-5">
          <div className="card-header">
            <i className="fa fa-info mr-2"></i> Quantity of material required
            for given construction area
          </div>
          <div className="card-body">
            <div className="row mt-1">
              <div className="col-md-6">
                <div class="card" style={{ width: "30rem" }}>
                  <div class="card-header">
                    Quantity of material required for {area} ft<sup>2</sup>
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                    <i className="fa fa-hourglass-half mr-2"></i> Cement{" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#428bca",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {cementUsage} Bags
                      </span>
                    </li>
                    <li class="list-group-item">
                    <i className="fa fa-hourglass-half mr-2"></i>Sand{" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#89c4f4",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {sandUsage} Ton
                      </span>
                    </li>
                    <li class="list-group-item">
                    <i className="fa fa-hourglass-half mr-2"></i>Aggregate{" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#dfba49",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {aggregateUsage} Ton
                      </span>
                    </li>
                    <li class="list-group-item">
                    <i className="fa fa-hourglass-half mr-2"></i>Steel{" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#45b6af",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {steelUsage} Kg.
                      </span>
                    </li>
                    <li class="list-group-item">
                    <i className="fa fa-hourglass-half mr-2"></i>Paint{" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#f3565d",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {paintUsage} It.
                      </span>
                    </li>
                    <li class="list-group-item">
                    <i className="fa fa-hourglass-half mr-2"></i>Bricks{" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#45b6af",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {bricksUsage} Pcs.
                      </span>
                    </li>
                    <li class="list-group-item">
                    <i className="fa fa-hourglass-half mr-2"></i>Flooring{" "}
                      <span
                        className="float-right"
                        style={{
                          background: "#f3565d",
                          color: "white",
                          padding: "0px 5px",
                        }}
                      >
                        {flooringUsage} ft<sup>2</sup>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div style={{ position: "relative", width: "25vw" }}>
                  <FadeIn>
                    <Pie data={pieChartData} />
                  </FadeIn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};
export default Calculator;
